import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Product } from '../../../types/Product';
import { calculateCategoryDistribution } from '../../../utils/statistics/charts';

interface CategoryDistributionChartProps {
  products: Product[];
}

const COLORS = ['#F97316', '#22C55E', '#3B82F6', '#A855F7', '#EC4899'];

export const CategoryDistributionChart: React.FC<CategoryDistributionChartProps> = ({ products }) => {
  const data = calculateCategoryDistribution(products);

  return (
    <div>
      <h4 className="text-lg font-medium mb-4">Distribución por Categorías</h4>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((_, index) => (
                <Cell 
                  key={`cell-${index}`} 
                  fill={COLORS[index % COLORS.length]}
                  stroke="#fff"
                  strokeWidth={2}
                />
              ))}
            </Pie>
            <Tooltip 
              formatter={(value: number) => [`${value}%`, 'Productos']}
              contentStyle={{ backgroundColor: 'white', borderRadius: '0.5rem' }}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};